export default __webpack_public_path__ + "static/media/line-h-07.2802686f.png";